<template>
  <div class="item-list">
    <loading-screen v-if="loading" />
    <div v-if="!loading" class="container mx-auto">
      <div v-if="config && config.filterBy" class="filters is-hidden-touch">
        <b-button
          :variant="selectedCategory === null ? 'primary' : 'secondary'"
          class="mr-4 mb-4"
          @click="setSelectedCategory(null)"
        >
          All
        </b-button>
        <b-button
          v-for="(filter, index) in filters"
          :key="`filter-${index}`"
          :variant="filter === selectedCategory ? 'primary' : 'secondary'"
          class="mr-4 mb-4"
          @click="setSelectedCategory(filter)"
        >
          {{ filter }}
        </b-button>
      </div>
      <div v-if="config" class="flex flex-wrap -mx-2">
        <div
          v-for="item in filteredItems"
          :key="`item-${item.id}`"
          class="w-full md:w-1/2 lg:w-1/3 xl:w-1/4 px-2 mb-4"
        >
          <router-link
            :to="{ name: 'detail-view', params: { slug: item.slug } }"
          >
            <b-content-card :item="item" :config="config" />
          </router-link>
        </div>
      </div>
      <div>
        <div>
          <div v-show="!items.length">
            No data to show
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BContentCard from "@/components/BContentCard";
import LoadingScreen from "@/components/LoadingScreen";
import categories from "@/constants/categories";

export default {
  name: "ListView",

  components: {
    BContentCard,
    LoadingScreen
  },

  data() {
    return {
      loading: true
    };
  },

  computed: {
    config() {
      return this.$store.state.config.listView;
    },
    items() {
      return this.$store.state.items;
    },
    filteredItems() {
      if (this.config && this.config.filterBy && this.config.filterBy.name) {
        return this.items.filter(item =>
          this.selectedCategory === null
            ? this.isInString(item[this.config.filterBy.name], this.searchTerm)
            : item[this.config.filterBy.name] === this.selectedCategory &&
              this.isInString(item[this.config.filterBy.name], this.searchTerm)
        );
      }
      return this.items;
    },
    filters() {
      return this.$store.state.filters;
    },
    searchTerm() {
      return this.$store.state.searchTerm;
    },
    selectedCategory() {
      return this.$store.state.selectedCategory;
    }
  },

  watch: {
    config(newVal) {
      if (newVal) {
        this.getItems();
      }
    }
  },

  beforeMount() {
    if (!this.items.length && this.config) {
      this.getItems();
    } else if (!this.config) {
      this.loading = true;
    } else {
      this.loading = false;
    }
  },

  methods: {
    isInString(a, b) {
      return b.toLowerCase()
        ? a.toLowerCase().search(b.toLowerCase()) > -1
        : true;
    },
    setSelectedCategory(category) {
      this.$store.commit("setSelectedCategory", category);
    },

    async getItems() {
      this.loading = true;
      await this.$store.dispatch("getItems");
      this.loading = false;
    }
  }
};
</script>

<style lang="scss" scoped>
.item-list {
  height: 100%;
}

.filters {
  display: flex;
  flex-wrap: wrap;
  padding-bottom: 30px;
}
</style>
